import React, { useState, useEffect } from 'react';
import {
  IonContent,
  IonPage,
  IonButton,
  IonRow,
  IonCol,
  IonBadge
} from '@ionic/react';
import AppHeader from '../components/AppHeader';
import AppointmentCard from '../components/AppointmentCard';
import { Appointment, Patient } from '../models';
import PatientRepository from '../repositories/PatientRepository';
import PatientSwitcher from '../components/PatientSwitcher';
import { AuthenticationRootState } from '../store/reducers/authentication';
import { connect } from 'react-redux';
import { unilabsHome } from '../const';

const mapStateToProps = (
  state: { authentication: AuthenticationRootState },
  ownProps: any
) => {
  return {
    user: state.authentication.user!
  };
};

const MyAppointments: React.FC<ReturnType<typeof mapStateToProps>> = ({
  user
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [appointments, setAppointments] = useState<Appointment[]>([]);
  const [filteredAppointments, setFilteredAppointments] =
    useState(appointments);
  const [activeAppointments, setActiveAppointments] = useState<Appointment[]>(
    []
  );
  const [finishedAppointments, setFinishedAppointments] = useState<
    Appointment[]
  >([]);

  const [currentEditionPatient, setCurrentEditionPatient] = useState<Patient>(
    user.patient
  );

  async function fetchAppointments() {
    setIsLoading(true);
    setAppointments(await PatientRepository.getAppointments());
    setIsLoading(false);
  }

  useEffect(() => {
    fetchAppointments();
  }, []);

  useEffect(() => {
    setFilteredAppointments(
      appointments.filter(
        (appointment) => appointment.patient?.id === currentEditionPatient.id
      )
    );
  }, [appointments, currentEditionPatient.id]);

  useEffect(() => {
    setActiveAppointments(
      filteredAppointments.filter((appointment) => {
        return !appointment.isFinished();
      })
    );

    setFinishedAppointments(
      filteredAppointments.filter((appointment) => {
        return appointment.isFinished();
      })
    );
  }, [filteredAppointments]);

  return (
    <IonPage>
      <AppHeader />
      <IonContent>
        <div className="ion-padding wrapper wrapper--large">
          <IonRow className="ion-align-items-center ion-justify-content-between">
            <IonCol>
              <h2>Mes Créneaux de prise en charge</h2>
            </IonCol>
            <IonCol size="auto">
              <IonButton
                href={`${unilabsHome}/trouver-un-laboratoire`}
                size="small"
              >
                Nouveau créneau de prise en charge
              </IonButton>
            </IonCol>
          </IonRow>
          <PatientSwitcher
            className="ion-margin-bottom"
            defaultPatient={currentEditionPatient}
            onSelectPatient={(patient: Patient) =>
              setCurrentEditionPatient(patient)
            }
          />
          {!isLoading ? (
            <>
              {activeAppointments.length ? (
                activeAppointments.map((appointment) => (
                  <AppointmentCard
                    appointment={appointment}
                    key={appointment.id}
                    onBeforeDelete={() => setIsLoading(true)}
                    onDelete={fetchAppointments}
                    showCheckin={true}
                  />
                ))
              ) : (
                <div className="ion-text-center ion-padding">
                  <IonBadge color="warning" className="ion-text-wrap">
                    Vous n'avez pas de créneau de prise en charge à venir pour
                    ce patient.
                  </IonBadge>
                </div>
              )}
              <>
                <IonRow className="ion-align-items-center ion-justify-content-between">
                  <IonCol>
                    <h2>Historique du patient</h2>
                  </IonCol>
                </IonRow>
                {finishedAppointments.length ? (
                  finishedAppointments.map((appointment) => (
                    <AppointmentCard
                      appointment={appointment}
                      key={appointment.id}
                    />
                  ))
                ) : (
                  <div className="ion-text-center ion-padding">
                    <IonBadge color="warning" className="ion-text-wrap">
                      Aucun historique pour ce patient
                    </IonBadge>
                  </div>
                )}
              </>
            </>
          ) : (
            <AppointmentCard />
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default connect(mapStateToProps, null)(MyAppointments);
